// API URLs configuration
export const API_URL = import.meta.env.VITE_API_URL;
export const FASTAPI_URL = import.meta.env.VITE_FASTAPI_URL || 'http://localhost:8000'; 